import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Grid, Typography, Avatar, LinearProgress } from '@mui/material';
import Container from './Container';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const DashboardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.background.default,
  height: '100vh',
  overflow: 'hidden',
}));

const Content = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  overflowY: 'auto',
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 24,
  height: 24,
  marginRight: theme.spacing(1),
}));

const ProgressBar = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 4,
}));

const Dashboard: React.FC = () => {
  const chartData = {
    labels: ['12:00AM', '3:00PM', '6:00PM', '9:00PM', '12:00PM'],
    datasets: [
      {
        label: 'Website Visitors',
        data: [0, 300, 200, 600, 800],
        fill: false,
        borderColor: 'rgb(75, 192, 192)',
        tension: 0.1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
  <DashboardContainer>
    <Content>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Container title="REVIEWS">
            <Typography variant="h4">1,281</Typography>
            <Typography variant="body2" color="textSecondary">
              You got +23.8% more reviews than last week
            </Typography>
            <Box display="flex" mt={2}>
              <StyledAvatar src="avatar.jpg" />
              <StyledAvatar src="avatar.jpg" />
              <StyledAvatar src="avatar.jpg" />
              <StyledAvatar src="avatar.jpg" />
            </Box>
          </Container>
        </Grid>
        <Grid item xs={12} md={4}>
          <Container title="AV. RATING">
            <Typography variant="h4">4.6</Typography>
            <Typography variant="body2" color="textSecondary">
              +0.3 points from last week
            </Typography>
            <Box display="flex" justifyContent="space-between" mt={2}>
              {[1, 2, 3, 4, 5, 6, 7].map((day) => (
                <Box key={day} display="flex" flexDirection="column" alignItems="center">
                  <Typography variant="caption">{['M', 'T', 'W', 'T', 'F', 'S', 'S'][day - 1]}</Typography>
                  <Box width={4} height={20} bgcolor="primary.main" mt={1} />
                </Box>
              ))}
            </Box>
          </Container>
        </Grid>
        <Grid item xs={12} md={4}>
          <Container title="SENTIMENT ANALYSIS">
            <Box mb={2}>
              <Typography variant="body2">Positive Reviews</Typography>
              <ProgressBar variant="determinate" value={80} color="primary" />
              <Typography variant="body2">960</Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body2">Neutral Reviews</Typography>
              <ProgressBar variant="determinate" value={10} color="secondary" />
              <Typography variant="body2">122</Typography>
            </Box>
            <Box>
              <Typography variant="body2">Negative Reviews</Typography>
              <ProgressBar variant="determinate" value={30} color="error" />
              <Typography variant="body2">321</Typography>
            </Box>
          </Container>
        </Grid>
        <Grid item xs={12}>
          <Container title="WEBSITE VISITORS">
            <Typography variant="h4">821</Typography>
            <Typography variant="body2" color="textSecondary">
              Visitors Today
            </Typography>
            <Box height={300} mt={2}>
              <Line data={chartData} options={chartOptions} />
            </Box>
          </Container>
        </Grid>
      </Grid>
    </Content>
  </DashboardContainer>

  );
};

export default Dashboard;
